export default {"src":"/_next/static/media/ic_league_rank_1.d05956c0.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};